export function getDateObject(timeStr) {
    let dateObj;
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        dateObj = new Date(timeStr.replace(/\s/, 'T'));
    } else {
        dateObj = new Date(timeStr);
    }
    return dateObj;
}